import React, { useState } from "react"

import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import { useOnboardedInvestorMutation } from "store/api/wealthpartnerapi/onboard.api"
import { useNavigate } from "react-router-dom"

const defaultValues = {
  entity_type: "COMPANY",
  name: "",
  preference: ["ICD"],
  email: "",
  pan_no: "",
  phone: "",
}

function AddOnboardModal({ open, setOpen }) {
  const navigate = useNavigate()
  const toggle = () => setOpen(!open)
  const [onboardInvestor, { isLoading }] = useOnboardedInvestorMutation()

  const onFormSubmit = async (values) => {
    try {
      const { data, message, success } = await onboardInvestor(values).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        navigate(`/investor-management/onboard/${data.id}`)
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await onFormSubmit(values)
    },
  })

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered>
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Onboard Investor
        </ModalHeader>
        <ModalBody>
          <Container>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row className="mb-2">
                {/* <Col xl={12} className="mb-2">
                  <Label className="form-label">Entity Type</Label>
                  <select
                    name="entity_type"
                    className="form-select pageSize mb-2"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.entity_type || ""}
                  >
                    {[
                      { label: "Individual", value: "INDIVIDUAL" },
                      { label: "Business", value: "COMPANY" },
                    ].map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  {validation.touched.entity_type &&
                  validation.errors.entity_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.entity_type}
                    </FormFeedback>
                  ) : null}
                </Col> */}
                <Col xl={12} className="mb-2">
                  <Label className="form-label">
                    {validation.values.entity_type === "INDIVIDUAL"
                      ? "Name"
                      : "Company Name"}
                  </Label>
                  <Input
                    name="name"
                    className="form-control"
                    placeholder={
                      validation.values.entity_type === "INDIVIDUAL"
                        ? "Enter Name"
                        : "Enter Company Name"
                    }
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12} className="mb-2">
                  <Label className="form-label">Email Address</Label>
                  <Input
                    name="email"
                    className="form-control"
                    placeholder="Enter Email Address"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  ) : null}{" "}
                </Col>

                <Col xl={12} className="mb-2">
                  <Label className="form-label">Phone No</Label>
                  <Input
                    name="phone"
                    className="form-control"
                    placeholder="Phone No"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone || ""}
                    invalid={
                      validation.touched.phone && validation.errors.phone
                        ? true
                        : false
                    }
                  />
                  {validation.touched.phone && validation.errors.phone ? (
                    <FormFeedback type="invalid">
                      {validation.errors.phone}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12} className="mb-2">
                  <Label className="form-label">PAN</Label>
                  <Input
                    name="pan_no"
                    className="form-control"
                    placeholder="PAN"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.pan_no || ""}
                    invalid={
                      validation.touched.pan_no && validation.errors.pan_no
                        ? true
                        : false
                    }
                  />
                  {validation.touched.pan_no && validation.errors.pan_no ? (
                    <FormFeedback type="invalid">
                      {validation.errors.pan_no}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>

              <div className="mt-3 py-1 button-wrapper">
                <Button
                  type="submit"
                  color="primary"
                  className="w-100"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinners /> : "Save & Onboard Investor"}
                </Button>
              </div>
            </Form>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AddOnboardModal
